import {cipo} from "cipo";


cipo.controller('videoPlayerController', function (fileUrl, title, $mdDialog, $scope) {

    // VARIABLES
    $scope.fileUrl = fileUrl || null;
    $scope.title = title || '';

    // METHODS
    $scope.close = _close;

    function _close() {
        $mdDialog.cancel();
    }
});